export enum SketchEditActionEnum {
  RemoveFromPending = 1,
  Merge = 2,
  Split = 3,
  Change = 4,
  ChangeTime = 5,
  ReplaceExisting = 6,
  publicTransport = 7,
  AddToPending = 8,
}
